import {MATRIZ_PERMISOS} from './matrizPermisos'

export const normalizarValorPermiso = (valor = '') =>
  valor
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

export const requiereTipoFacturacion = (modulo) =>
  Boolean(MATRIZ_PERMISOS[modulo]?.tiposFacturacion?.length)

export const evaluarPermiso = ({modulo, rol, tipoFacturacion}) => {
  const politica = MATRIZ_PERMISOS[modulo]
  if (!politica) return false

  const rolNormalizado = normalizarValorPermiso(rol)
  const facturacionNormalizada = normalizarValorPermiso(tipoFacturacion)
  const rolPermitido = politica.roles.includes(rolNormalizado)
  const facturacionPermitida =
    !politica.tiposFacturacion ||
    politica.tiposFacturacion.includes(facturacionNormalizada)

  return rolPermitido && facturacionPermitida
}

